import React from 'react';
import { IonButton } from '@ionic/react';
import { MapButtonsHolder, MapContainer, MapHolder } from './mapStyles';
import { NavigateIcon, VirtualTourIcon } from '../../Global/Icons/Icons';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';
import ShowSingleTrail from '../../Mapping/ShowSingleTrail';
import { Trail } from '../../../models/Trail';
import SingleTrailMap from '../../MapComponents/SingleTrailMap';

type MapProps = {
	trail: Trail;
	setIsVTOpen: React.Dispatch<React.SetStateAction<any>>;
	setIsNavOpen: React.Dispatch<React.SetStateAction<any>>;
};

const Map: React.FC<MapProps> = ({ trail, setIsVTOpen, setIsNavOpen }) => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	return (
		<MapContainer>
			<MapHolder>
				<SingleTrailMap trail={trail} />
			</MapHolder>
			<MapButtonsHolder>
				<IonButton
					color={'primary'}
					onClick={() => setIsNavOpen(true)}>
					<NavigateIcon />
					Start Trail
				</IonButton>
				{network_status && (
					<IonButton
						color={'primary'}
						onClick={() => setIsVTOpen(true)}>
						<VirtualTourIcon />
						Virtual Tour
					</IonButton>
				)}
			</MapButtonsHolder>
		</MapContainer>
	);
};

export default Map;
